import useTemplateInstance from "../../../hooks/useTemplateInstance";
import React, { useEffect, useMemo, useRef } from "react";
import useComponentSize from "@rehooks/component-size";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { getBoxSize } from "../../../../../utils";
import DrawTemplate from "../../../../../components/Template/DrawTemplate";
import { getFirstRenderPartByResource } from "../../../../../Providers/TemplateInstanceProvider";

const useStyles = makeStyles((theme) => ({
  templateContainer: {
    position: "absolute",
    "& .template-inner-container": {
      transition: "transform 0.3s",
      transitionTimingFunction: "ease-in",
    },
    "&.separate-from-background .template-inner-container": {
      boxShadow: "0px 3px 6px #00000029",
    },
  },
  templateOuterContainer: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    // Disable pull to refresh
    touchAction: "none",
    backgroundColor: (props) =>
      props.partOfPackage ? theme.palette.secondary.light : "initial",
  },
}));

const TemplateContainer = ({ children, ...props }) => {
  const [state] = useTemplateInstance();
  const classes = useStyles({ ...props, partOfPackage: state.partOfPackage });

  const ref = useRef();
  const size = useComponentSize(ref);

  const [cSize, style, outerPos] = useMemo(() => {
    let horizontalPadding = 30;
    let verticalPadding = 10;

    // Hack ref Eyvind: If the width of the renderpart is a small portion of the template,
    // make more padding so we see more of the context
    if (props.zoomResource && props.zoomResource.type == "STRING") {
      const renderPart = getFirstRenderPartByResource(
        props.zoomResource,
        state.template,
      );
      const templateWidth = state.template.dimensions.width;

      // FIXME: Width should be relative to DPI
      if (
        renderPart.size.width < 100 ||
        renderPart.size.width / templateWidth <= 0.1
      ) {
        horizontalPadding = 60;
        verticalPadding = 30;
      }
    }

    let visibleArea = state.template.dimensions;

    if (state.template.trimBox) {
      visibleArea = state.template.trimBox;
    }

    const cSize = getBoxSize("fit-in", visibleArea, {
      width: size.width - horizontalPadding * 2,
      height: size.height - verticalPadding * 2,
    });
    const outerPos = {
      x: cSize.x,
      y: cSize.y,
      width: size.width - horizontalPadding * 2,
      height: size.height - verticalPadding * 2,
    };

    const style = {
      width: cSize.width + "px",
      height: cSize.height + "px",
      left: cSize.x + horizontalPadding + "px",
      top: cSize.y + verticalPadding + "px",
    };
    return [cSize, style, outerPos];
  }, [size, state]);

  return (
    <div className={classes.templateOuterContainer} ref={ref}>
      <div
        className={`${classes.templateContainer} ${
          props.zoomResource ? "zoomed" : ""
        } ${
          state.template.separateFromBackground
            ? "separate-from-background"
            : ""
        }`}
        style={style}
      >
        <DrawTemplate
          templateInstance={state}
          containerSize={cSize}
          outerPosition={outerPos}
          {...props}
        />
      </div>
      {children}
    </div>
  );
};
export default TemplateContainer;
